// 定义路由
import { createRouter, createWebHistory } from "vue-router";
const routes = [
    //首页
    // { path: '/', name: 'home', meta: {allowBack: false}, component: () => import('../pages/home') }, //老版本首页
    { path: '/', name: 'home', meta: {allowBack: false}, component: () => import('../pages/newHome') },
    //产品中心
    { path: '/productCenter', name: 'productCenter', meta: {allowBack: false,keepAlive: true}, component: () => import('../pages/productCenter') },
    //产品详情
    { path: '/imgProductDetails', name: 'imgProductDetails', meta: {allowBack: false}, component: () => import('../pages/products/imgProductDetails') },
    { path: '/imgProductDetailsAddText', name: 'imgProductDetailsAddText', meta: {allowBack: false}, component: () => import('../pages/products/imgProductDetailsAddText') },
    //软件平台（兼容旧地址，统一进入星极智航详情）
    { path: '/softwarePlatform', redirect: { path: '/imgProductDetailsAddText', query: { product_name: '星极智航' } } },
    //AI算法
    { path: '/aiAlgorithm', name: 'aiAlgorithm', meta: {allowBack: false}, component: () => import('../pages/aiAlgorithm') },
    //视觉识别自主标注系统
    { path: '/labelingSystem', name: 'labelingSystem', meta: {allowBack: false}, component: () => import('../pages/labelingSystem') },
    //研发项目管理平台
    { path: '/projectManagement', name: 'projectManagement', meta: {allowBack: false}, component: () => import('../pages/projectManagement') },
    //解决方案
    { path: '/solution', name: 'solution', meta: {allowBack: false}, component: () => import('../pages/solution') },
    //解决方案分行业
    { path: '/solutionByIndustry', name: 'solutionByIndustry', meta: {allowBack: false}, component: () => import('../pages/solutionItem/solutionByIndustry') },
    //解决方案行业详情
    { path: '/solutionByIndustryContent', name: 'solutionByIndustryContent', meta: {allowBack: false}, component: () => import('../pages/solutionItem/solutionByIndustryContent') },
    //服务案例
    { path: '/example', name: 'example', meta: {allowBack: false}, component: () => import('../pages/example/index') },
    //服务案例详情
    { path: '/caseContent', name: 'caseContent', meta: {allowBack: false}, component: () => import('../pages/caseContent') },
    //公司简介
    { path: '/companyIntroduction', name: 'companyIntroduction', meta: {allowBack: false}, component: () => import('../pages/companyIntroduction') },
    //服务支持
    { path: '/serviceSupport', name: 'serviceSupport', meta: {allowBack: false}, component: () => import('../pages/serviceSupport') },
    //平台账号注册
    { path: '/platformRegister', name: 'platformRegister', meta: {allowBack: false}, component: () => import('../pages/platformRegister') },
    //联系我们
    { path: '/contactInformation', name: 'contactInformation', meta: {allowBack: false}, component: () => import('../pages/contactInformation') },
    //解决方案测绘
    { path: '/mapping', name: 'mapping', meta: {allowBack: false}, component: () => import('../pages/solutionItem/mapping') },
    //解决方案测绘详情页
    { path: '/mappingContent', name: 'mappingContent', meta: {allowBack: false}, component: () => import('../pages/solutionItem/mappingContent') },
    //解决方案电力
    { path: '/electric', name: 'electric', meta: {allowBack: false}, component: () => import('../pages/solutionItem/electric') },
    //解决方案公共安全
    { path: '/publicSafety', name: 'publicSafety', meta: {allowBack: false}, component: () => import('../pages/solutionItem/publicSafety') },
    //解决方案公共安全详情页
    { path: '/publicSafetyContent', name: 'publicSafetyContent', meta: {allowBack: false}, component: () => import('../pages/solutionItem/publicSafetyContent') },
    //解决方案石油与天然气
    { path: '/oilAndGas', name: 'oilAndGas', meta: {allowBack: false}, component: () => import('../pages/solutionItem/oilAndGas') },
    //解决方案石油与天然气详情页
    { path: '/oilAndGasContent', name: 'oilAndGasContent', meta: {allowBack: false}, component: () => import('../pages/solutionItem/oilAndGasContent') },
    //解决方案数据保护
    { path: '/dataProtection', name: 'dataProtection', meta: {allowBack: false}, component: () => import('../pages/solutionItem/dataProtection') },
    //解决方案数据保护详情页
    { path: '/dataProtectionContent', name: 'dataProtectionContent', meta: {allowBack: false}, component: () => import('../pages/solutionItem/dataProtectionContent') },
    //解决方案企业应用
    { path: '/application', name: 'application', meta: {allowBack: false}, component: () => import('../pages/solutionItem/application') },
    //解决方案企业应用详情页
    { path: '/applicationContent', name: 'applicationContent', meta: {allowBack: false}, component: () => import('../pages/solutionItem/applicationContent') },

]

// 创建路由实例
const router = createRouter({
    // 采用 createWebHistory 路由模式 不带#
    history: createWebHistory(process.env.BASE_URL),
    routes,
    scrollBehavior(to, from, savedPosition) {
        return {top:0}
    }
})

export default router